import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useCommanderSelector } from '@mews-commander/utils';
import { getPlatformEnvironment } from '../../app/reducers/configuration';
import { getBookingEngineUpsellingApplicationId } from './bookingEngineLink';

export const useBookingEngineUpsellingUrl = () => {
    const resolveRoute = useResolveRoute();

    const environment = useCommanderSelector(getPlatformEnvironment);
    const enterpriseId = useCurrentEnterpriseId();
    const applicationId = getBookingEngineUpsellingApplicationId(environment);

    return resolveRoute(RouteName.EnterpriseIntegrationMarketplace, {
        query: {
            OwnerId: enterpriseId,
            ApplicationId: applicationId,
        },
    });
};
